<h1 mat-dialog-title>Change Masterpassword</h1>
<p><b>IMPORTANT:</b> do not lose this key else your data will be lost</p>
<div mat-dialog-content>
  <p>
    <mat-form-field>
      <mat-label for="old-password">old password</mat-label>
      <input
        matInput
        type="password"
        id="old-password"
        [(ngModel)]="old_password"
      />
    </mat-form-field>
  </p>
  <p>
    <mat-form-field>
      <mat-label for="new-password">new password</mat-label>
      <input
        matInput
        type="password"
        id="new-password"
        [(ngModel)]="new_password"
      />
    </mat-form-field>
  </p>
  <p>
    <mat-form-field>
      <mat-label for="repeat-password">repeat password</mat-label>
      <input
        matInput
        type="password"
        id="repeat-password"
        [(ngModel)]="repeated_password"
      />
    </mat-form-field>
  </p>
</div>
<div mat-dialog-actions>
  <button id="close" mat-button (click)="close()">Close</button>
  <button id="change" mat-button (click)="changePassword()">Change</button>
</div>
